// removed by extract-text-webpack-plugin
module.exports = {"content":"ResetPassword__content__1HUpi","parentContainer":"ResetPassword__parentContainer__2Q-t_","loginForm":"ResetPassword__loginForm__2PaNU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResetPassword/ResetPassword.css
// module id = 1497
// module chunks = 0